import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModules } from '@SharedModules/shared-modules.module';
import { PrimengModule } from '@SharedModules/primeng.module';
import { TableDynamicComponent } from '@sharedComponents/table-dynamic/table-dynamic.component';
import { ModalBasicComponent } from '@sharedComponents/modal-basic/modal-basic.component';

import { EquipmentsRoutingModule } from './equipments-routing.module';
import { EquipmentsListComponent } from './components/equipments-list/equipments-list.component';
import { EquipmentDetailPageComponent } from './components/equipment-detail-page/equipment-detail-page.component';
import { EquipmentFormComponent } from './components/equipment-form/equipment-form.component';
import { FileAttachmentsComponent } from '@sharedComponents/file-attachments/file-attachments.component';
import { CalendarModule } from 'angular-calendar';
import { AgendaComponent } from './components/agenda/agenda.component';
import { EquipmentEventDrawerComponent } from './components/equipment-event-drawer/equipment-event-drawer.component';

@NgModule({
  declarations: [
    EquipmentsListComponent,
    EquipmentDetailPageComponent,
    EquipmentFormComponent,
    AgendaComponent,
    EquipmentEventDrawerComponent
  ],
  imports: [
    CommonModule,
    EquipmentsRoutingModule,
    SharedModules,
    PrimengModule,
    FormsModule,
    ReactiveFormsModule,
    TableDynamicComponent,
    ModalBasicComponent,
    FileAttachmentsComponent,
    CalendarModule
  ],
  exports: [
  ]
})
export class EquipmentsModule { }
